import {
  Box,
  Button,
  Container,
  Divider,
  Fab,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { TabContainer } from "../../common/tab";
import React, { useEffect, useState } from "react";
import { TextFieldSearch } from "../../common/fieldText";
import {
  addAllowance,
  addSalaryComponent,
  addSalaryDeduction,
  addSalaryIncentive,
  getA,
  getAllDeduction,
  getAllSalaryComponent,
  getAllaallownce,
  getData,
  updateAllowance,
  updateSalaryComponent,
  updateSalaryDeduction,
  updateSalaryIncentive,
} from "./paymentApi";
import AddIcon from "@mui/icons-material/Add";

import { useSelector } from "react-redux";
import PaymentModal from "./paymentModal";
import PoprchModal from "./popSearch";
import CardPayment from "./cardPayment";
import PaymentIncentiveModal from "./paymetIncent";
import PaymentDeduction from "./paymentDeduction";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import PaymentAllowance from "./allowancemodal";
import AddSalaryComponent from "./salaryComponentAdd.jsx";
import AddModalProdcut from "../../common/productAddModal";
import FormSalary from "./formSalart";
import FormIncentive from "./formDataIncentive";
import FormDeduction from "./formDataDeduction";
import FormOtherAllowance from "./formDataOtherAllowance";
import Swal from "sweetalert2";
import { swalAlertPopProps } from "../../utils/commonUtils";
import UpdateComponentModal from "./componentModal.jsx";
import AccordianCards from "./accordianCards.jsx";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { getAllEmployeeList } from "../employeeInfo/appoinmentDashboardApi.js";
import Heading from "../../common/Heading.jsx";

const PaymentStruct = () => {
  const [chooseId, setChooseId] = useState(null);
  const [formda, setFormda] = useState({
    // empId: "",
    // componentDetails: []
  });

  const [updateflat, setUpdateFlag] = useState({
    salary: false,
  });

  const [formdat, setFormdat] = useState({
    employeeId: "",
    incentiveName: "",
    minimumValue: "",
    maximumValue: "",
    percentage: "",
    amount: "",
  });
  const [formdatTDence, setFormdatTDence] = useState({
    employeeId: "",
    componentName: "",
    amount: "",
    percentage: "",
  });

  const [formdatTAllowance, setFormdatTAllowance] = useState({
    employeeId: "",
    allowanceName: "",
    amount: "",
  });

  const [collectionData, setCollectionData] = useState([]);
  const [searchModal, setSearchModal] = useState(false);
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const [cardValue, setCardValue] = useState(null);

  const [formData, setFormKData] = useState({
    SalaryComponents: {
      formKey: {
        customerName: "",
        componentName: "",
        amount: "",
        percentage: "",
        employeeId: "",
      },
    },
    incentive: {
      formKey: {
        employeeId: "",
        incentiveName: "",
        minimumValue: "",
        maximumValue: 0,
        percentage: 0,
      },
    },
  });

  useEffect(() => {
    console.log("formda formda ttt", formda);
  }, [formda]);

  const getDataFn = () => {
    if (value == "SalaryComponents") {
      getAllSalaryComponent((data) => {
        console.log("data?.data?.data?.list", data?.data?.data?.list);

        setContainerData((prev) => {
          return { ...prev, SalaryComponents: data?.data?.data?.list };
        });
      });
    } else if (value == "incentive") {
      getData((data) => {
        console.log("data data ", data?.data?.data?.list);
        // setFormdaData(data?.data?.data?.list);

        setContainerData((prev) => {
          return { ...prev, incentive: data?.data?.data?.list };
        });
      });
    } else if (value == "Deductions") {
      getAllDeduction((data) => {
        console.log("data?.data?.data?.list getall", data?.data?.data?.list);

        setContainerData((prev) => {
          return { ...prev, Deductions: data?.data?.data?.list };
        });
      });
    } else if (value == "otherAllowence") {
      getAllaallownce((data) => {
        console.log("data?.data?.data?.list getall", data?.data?.data?.list);

        setContainerData((prev) => {
          return { ...prev, otherAllowence: data?.data?.data?.list };
        });
      });
    }
  };

  useEffect(() => {
    if (cardValue) {
      getA(
        {
          pageSize: 10000,
          page: 1,

          filter: "name",
          search: cardValue.name,
        },
        (data) => {
          console.log("responseddd ", data);
        }
      );
    }
  }, [cardValue]);

  const [collectionSalaryComponent, setCollectionOfSalaryComponent] = useState(
    []
  );

  const cardKet = {
    SalaryComponents: [
      [
        {
          key: "employeeId",
          label: "Employee Id",
        },
        {
          key: "employeeName",
          label: "Employee Name",
        },
        {
          key: "totalAmount",
          label: "Totol Amount",
        },
      ],
      [
        {
          key: "componentName",
          label: "Component Name",
        },
        {
          key: "amount",
          label: "Amount",
        },
      ],
    ],

    incentive: [
      [
        {
          key: "employeeId",
          label: "Employee Id",
        },
        {
          key: "employeeName",
          label: "Employee Name",
        },
        {
          key: "totalAmount",
          label: "Totol Amount",
        },
      ],
      [
        {
          key: "incentiveName",
          label: "Incentive Name",
        },
        {
          key: "minimumValue",
          label: "Minimum Value",
        },
        {
          key: "maximumValue",
          label: "Maximum Value",
        },
        {
          key: "percentage",
          label: "Percentage",
        },
        {
          key: "amount",
          label: "Amount",
        },
      ],
    ],
    Deductions: [
      [
        {
          key: "employeeId",
          label: "Employee Id",
        },
        {
          key: "employeeName",
          label: "Employee Name",
        },
        {
          key: "totalAmount",
          label: "Totol Amount",
        },
      ],
      [
        {
          key: "componentName",
          label: "Deduction Name",
        },
        {
          key: "amount",
          label: "Amount",
        },
        // {
        //   key: "percentage",
        //   label: "Percentage",
        // },
      ],
    ],
    otherAllowence: [
      [
        {
          key: "employeeId",
          label: "Employee Id",
        },
        {
          key: "employeeName",
          label: "Employee Name",
        },
        {
          key: "totalAmount",
          label: "Totol Amount",
        },
      ],
      [
        {
          key: "allowanceName",
          label: "Allowance Name",
        },
        {
          key: "amount",
          label: "Amount",
        },
      ],
    ],
  };

  const componentFields = {
    SalaryComponents: [
      {
        label: "Component Name",
        name: "componentName",
        type: "text",
        placeholder: "Enter Component Name",
      },
      {
        label: "Amount",
        name: "amount",
        type: "number",
        placeholder: "Enter Amount",
      },
    ],
    incentive: [
      {
        label: "Incentive Name",
        name: "incentiveName",
        type: "text",
        placeholder: "Enter Incentive Name",
      },
      {
        label: "Minimum Value",
        name: "minimumValue",
        type: "number",
        placeholder: "Enter Minimum Value",
      },
      {
        label: "Maximum Value",
        name: "maximumValue",
        type: "number",
        placeholder: "Enter Maximum Value",
      },
      {
        label: "Percentage",
        name: "percentage",
        type: "number",
        placeholder: "Enter Percentage",
      },
      {
        label: "Amount",
        name: "amount",
        type: "number",
        placeholder: "Enter Amount",
      },
    ],
    Deductions: [
      {
        label: "Deduction Name",
        name: "componentName",
        type: "text",
        placeholder: "Enter Deduction Name",
      },
      {
        label: "Amount",
        name: "amount",
        type: "number",
        placeholder: "Enter Amount",
      },
      // {
      //   label: "Percentage",
      //   name: "percentage",
      //   type: "number",
      //   placeholder: "Enter Percentage",
      // },
    ],
    otherAllowence: [
      {
        label: "Allowance Name",
        name: "allowanceName",
        type: "text",
        placeholder: "Enter Allowance Name",
      },
      {
        label: "Amount",
        name: "amount",
        type: "number",
        placeholder: "Enter Amount",
      },
    ],
  };

  const [containerData, setContainerData] = useState({
    SalaryComponents: [],
    incentive: [],
    Deductions: [],
    otherAllowence: [],
  });
  useEffect(() => {
    console.log("containerData ", containerData);
  }, [containerData]);
  const [value, setValue] = useState("SalaryComponents");

  const tabfn = (event, newValue) => {
    // setPageNo(1);
    setValue(newValue);
  };

  useEffect(() => {
    getData((data) => {
      console.log("data data ", data?.data?.data?.list);
      // setFormdaData(data?.data?.data?.list);

      setContainerData((prev) => {
        return { ...prev, incentive: data?.data?.data?.list };
      });
    });
    getAllSalaryComponent((data) => {
      console.log("data?.data?.data?.list", data?.data?.data?.list);

      setContainerData((prev) => {
        return { ...prev, SalaryComponents: data?.data?.data?.list };
      });
    });
    getAllDeduction((data) => {
      console.log("data?.data?.data?.list getall", data?.data?.data?.list);

      setContainerData((prev) => {
        return { ...prev, Deductions: data?.data?.data?.list };
      });
    });
    getAllaallownce((data) => {
      console.log("data?.data?.data?.list getall", data?.data?.data?.list);

      setContainerData((prev) => {
        return { ...prev, otherAllowence: data?.data?.data?.list };
      });
    });
  }, []);

  useEffect(() => {
    console.log("containerData ", containerData);
  }, [containerData]);

  const [data, setData] = useState();

  const [open, setOpen] = useState(false);
  const [cardData, setCardData] = useState({});
  const [openComponentModal, setOpenComponentModal] = useState(false);
  const [componentData, setComponentData] = useState({
    id: 0,
    componentName: "",
    amount: 0.0,
    percentage: 0.0,
  });
  const [componentDataStruct, setComponentDataStruct] = useState({
    id: 0,
    componentName: "",
    amount: 0.0,
    percentage: 0.0,
  });

  const value_t = {
    salaryComponent: {
      value: "SalaryComponents",
      label: "Salary Components",
    },
    Incentive: {},
    Deductions: {},
  };
  const [openDeduction, setopenDeduction] = useState(false);
  const [opent, setOpent] = useState(false);

  const [openOtherAllowence, setopenOtherAllowence] = useState(false);

  const [search, setSearchvalue] = useState("");
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );
  useEffect(() => {
    if (businessChooseTab?.value) {
      setValue(businessChooseTab?.value);
      setSearchvalue("");
      setCardValue(null);
    }
  }, [businessChooseTab]);

  useEffect(() => {
    // if(businessChooseTab){
    //   setValue(businessChooseTab)
    // }
    console.log("businessChooseTab ", businessChooseTab);
    setValue(businessChooseTab?.value);
  }, [businessChooseTab]);

  useEffect(() => {
    console.log("openOtherAllowence ", openOtherAllowence);
  }, [openOtherAllowence]);
  useEffect(() => {
    getAllEmployeeList((res) => {
      console.log("getAllEmployeeList", res);
      setData(res?.list);
    });
    // getData(getAccountReachageDetails, setData);
  }, []);
  return (
    <>
      <Box
        px={{ sm: 4, xs: 2 }}
        pb={4}
        container="true"
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
          minHeight: "100vh",
        }}
      >
        <Heading
          name={
            value == "SalaryComponents"
              ? "Salary Components"
              : value == "incentive"
                ? "Incentive"
                : value == "Deductions"
                  ? "Deductions"
                  : value == "otherAllowence"
                    ? "Other Allowance"
                    : ""
          }
        />

        {/* <Grid
          item
          xs={12}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            mt: "10px",
            borderRadius: "5px",
            color: "#01008B", // optional text color
            textAlign: "left",
            marginBottom: {xs:"10px", sm:"20px"},
            fontFamily: "'Montserrat', sans-serif",
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
            fontWeight: 500,
          }}
        >
          <Typography
            variant="h6"
            fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
          >
            {value == "SalaryComponents"
              ? "Salary Components"
              : value == "incentive"
              ? "Incentive"
              : value == "Deductions"
              ? "Deductions"
              : value == "otherAllowence"
              ? "Other Allowance"
              : ""}
          </Typography>
        </Grid> */}

        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={10}>
              <TextField
                value={
                  search?.name ||
                  search?.employeeName ||
                  search?.employeeId ||
                  ""
                }
                label="Select Employee:"
                size="small"
                fullWidth
                variant="outlined"
                onClick={() => setSearchModal(true)}
                sx={{
                  backgroundColor: "white",
                  color: "#555555",
                  cursor: "pointer",
                  borderRadius: "4px",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "none",
                    },
                    "&:hover fieldset": {
                      border: "none",
                    },
                    "&.Mui-focused fieldset": {
                      border: "none",
                    },
                    cursor: "pointer",
                  },
                }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      {search?.employeeName ||
                      search?.employeeId ||
                      search?.name ? (
                        <CloseIcon
                          onClick={(e) => {
                            e.stopPropagation();
                            setSearchvalue("");
                            setCardValue("");
                          }}
                          sx={{
                            cursor: "pointer",
                            fontSize: { xs: "14px", sm: "14px", md: "15px" },
                          }}
                        />
                      ) : (
                        <SearchIcon
                          color="primary"
                          sx={{
                            cursor: "pointer",
                            fontSize: { xs: "14px", sm: "14px", md: "15px" },
                          }}
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  shrink: !!search,
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
              />

              <PoprchModal
                cardValue={cardValue}
                setCardValue={(data) => {
                  setSearchvalue(data);
                  setCardValue(data);
                }}
                callback={() => {}}
                searchModal={searchModal}
                setSearchModal={setSearchModal}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <Button
                fullWidth
                onClick={() => setOpen(true)}
                sx={{
                  textTransform: "capitalize",
                  whiteSpace: "nowrap",
                  zIndex: "0",
                  paddingX: "30px",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
                size="medium"
                color="primary"
                variant="contained"
                aria-label="add"
              >
                Add
                <AddIcon sx={{ marginLeft: "6px" }} />
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <PoprchModal
          config={{
            salary: true,
          }}
          cardValue={cardValue}
          setCardValue={(data) => {
            setSearchvalue(data);
            setCardValue(data);
          }}
          callback={() => {}}
          searchModal={searchModal}
          setSearchModal={setSearchModal}
        />
        <AddModalProdcut
          updateflat={updateflat}
          setUpdateFlag={setUpdateFlag}
          callback={() => {}}
          formda={formda}
          setFormda={setFormda}
          open={open}
          value={value}
          addUpdateApi={(payload) => {
            if (value == "otherAllowence") {
              let dataTemp = { ...payload };
              dataTemp["empId"] = parseInt(dataTemp?.empId);
              dataTemp.componentDetails.forEach((component) => {
                component.percentage = parseFloat(component.percentage ?? 0);
                component.amount = parseFloat(component.amount ?? 0);
                component.minimumValue = parseFloat(
                  component.minimumValue ?? 0,
                );
                component.maximumValue = parseFloat(
                  component.maximumValue ?? 0,
                );
              });
              if (updateflat) {
                updateAllowance(dataTemp, (res) => {
                  console.log("resresres ", res);
                  if (res.data?.succeeded) {
                    getDataFn();
                    setFormda(null);
                    Swal.fire({
                      text: "Updated Successfully",
                      icon: "success",
                      ...swalAlertPopProps,
                    });
                  } else {
                    Swal.fire({
                      title: res?.data?.message,
                      icon: "error",
                      ...swalAlertPopProps,
                    });
                  }
                });
              } else {
                addAllowance(dataTemp, (res) => {
                  console.log("resresres ", res);

                  if (res.data?.succeeded) {
                    getDataFn();
                    setFormda(null);
                    setOpen(false);
                    Swal.fire({
                      text: "Add Successfully",
                      icon: "success",
                      ...swalAlertPopProps,
                    });
                  } else {
                    Swal.fire({
                      title: res?.data?.message,
                      icon: "error",
                      ...swalAlertPopProps,
                    });
                  }
                });
              }
            }
            if (value == "SalaryComponents") {
              let dataTemp = { ...payload };
              dataTemp["empId"] = parseInt(dataTemp?.empId);
              dataTemp.componentDetails.forEach((component) => {
                component.percentage = parseFloat(component.percentage);
                component.amount = parseFloat(component.amount);
              });
              if (updateflat) {
                updateSalaryComponent(dataTemp, (res) => {
                  console.log("resresres ", res);
                  if (res.data?.data?.success) {
                    getDataFn();
                    setFormda(null);
                    Swal.fire({
                      text: "Updated Successfully",
                      icon: "success",
                      ...swalAlertPopProps,
                    });
                  } else {
                    Swal.fire({
                      title: res?.data?.message,
                      icon: "error",
                      ...swalAlertPopProps,
                    });
                  }
                });
              } else {
                addSalaryComponent(dataTemp, (res) => {
                  if (res.data?.succeeded) {
                    getDataFn();
                    setFormda(null);
                    setOpen(false);
                    Swal.fire({
                      text: "Add Successfully",
                      icon: "success",
                      ...swalAlertPopProps,
                    });
                  } else {
                    Swal.fire({
                      title: res?.data?.message,
                      icon: "error",
                      ...swalAlertPopProps,
                    });
                  }
                });
              }
            }
            if (value == "incentive") {
              let dataTemp = { ...payload };
              dataTemp["empId"] = parseInt(dataTemp?.empId);
              dataTemp.componentDetails.forEach((component) => {
                component.percentage = parseFloat(component.percentage ?? 0);
                component.amount = parseFloat(component.amount ?? 0);
                component.minimumValue = parseFloat(
                  component.minimumValue ?? 0,
                );
                component.maximumValue = parseFloat(
                  component.maximumValue ?? 0,
                );
              });
              if (updateflat) {
                updateSalaryIncentive(dataTemp, (res) => {
                  console.log("resresres ", res);
                  if (res.data?.succeeded) {
                    getDataFn();
                    setFormda(null);
                    Swal.fire({
                      text: "Updated Successfully",
                      icon: "success",
                      ...swalAlertPopProps,
                    });
                  } else {
                    Swal.fire({
                      title: res?.data?.message,
                      icon: "error",
                      ...swalAlertPopProps,
                    });
                  }
                });
              } else {
                addSalaryIncentive(dataTemp, (res) => {
                  console.log("resresres ", res);

                  if (res.data?.succeeded) {
                    getDataFn();
                    setFormda(null);
                    setOpen(false);
                    Swal.fire({
                      text: "Add Successfully",
                      icon: "success",
                      ...swalAlertPopProps,
                    });
                  } else {
                    Swal.fire({
                      title: res?.data?.message,
                      icon: "error",
                      ...swalAlertPopProps,
                    });
                  }
                });
              }
            }
            if (value == "Deductions") {
              let dataTemp = { ...payload };
              dataTemp["empId"] = parseInt(dataTemp?.empId);
              dataTemp.componentDetails.forEach((component) => {
                component.percentage = parseFloat(component.percentage ?? 0);
                component.amount = parseFloat(component.amount ?? 0);
              });
              if (updateflat) {
                updateSalaryDeduction(dataTemp, (res) => {
                  console.log("resresres ", res);
                  if (res.data?.succeeded) {
                    getDataFn();
                    setFormda(null);
                    Swal.fire({
                      text: "Updated Successfully",
                      icon: "success",
                      ...swalAlertPopProps,
                    });
                  } else {
                    Swal.fire({
                      title: res?.data?.message,
                      icon: "error",
                      ...swalAlertPopProps,
                    });
                  }
                });
              } else {
                addSalaryDeduction(dataTemp, (res) => {
                  console.log("resresres ", res);

                  if (res.data?.succeeded) {
                    getDataFn();
                    setFormda(null);
                    setOpen(false);
                    Swal.fire({
                      text: "Add Successfully",
                      icon: "success",
                      ...swalAlertPopProps,
                    });
                  } else {
                    Swal.fire({
                      title: res?.data?.message,
                      icon: "error",
                      ...swalAlertPopProps,
                    });
                  }
                });
              }
            }
          }}
          children={
            <>
              {value == "SalaryComponents" && (
                <FormSalary
                  formda={formda}
                  setFormda={setFormda}
                  open={open}
                  setOpen={setOpen}
                  existingComponents={containerData?.SalaryComponents || []}
                />
              )}

              {value == "incentive" && (
                <FormIncentive
                  formda={formda}
                  setFormda={setFormda}
                  open={open}
                  setOpen={setOpen}
                  existingComponents={containerData?.incentive || []}
                />
              )}
              {value == "Deductions" && (
                <FormDeduction
                  formda={formda}
                  setFormda={setFormda}
                  open={open}
                  setOpen={setOpen}
                  existingComponents={containerData?.Deductions || []}
                />
              )}
              {value == "otherAllowence" && (
                <FormOtherAllowance
                  formda={formda}
                  setFormda={setFormda}
                  open={open}
                  setOpen={setOpen}
                  existingComponents={containerData?.otherAllowence || []}
                />
              )}
            </>
          }
          setOpen={setOpen}
        ></AddModalProdcut>

        <Grid
          item
          xs={12}
          mt={2}
          sx={{
            backgroundColor: "#fff",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          <Grid container spacing={2} sx={{ paddingBottom: "5px" }}>
            <Grid
              item
              xs={value == "incentive" ? 5.5 : 3}
              sx={{ textAlign: "center" }}
            >
              <Typography
                sx={{
                  color: "primary.main",
                  fontWeight: 500,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Employee Id
              </Typography>
            </Grid>
            <Grid item xs={5} sx={{ textAlign: "left" }}>
              <Typography
                sx={{
                  color: "primary.main",
                  fontWeight: 500,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Employee Name
              </Typography>
            </Grid>
            {value != "incentive" && (
              <Grid item xs={3} sx={{ textAlign: "center" }}>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontWeight: 500,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Total
                </Typography>
              </Grid>
            )}
          </Grid>
          <Divider sx={{ backgroundColor: "#000" }} />
          <Grid container sx={{ pt: "10px" }}>
            <Grid
              item
              xs={12}
              sx={{
                padding: { xs: "1px", sm: "10px" },
                height: "60vh",
                overflowY: "auto",
              }}
            >
              <Grid container spacing={1}>
                {containerData[value]?.map((ele, index) => {
                  if (search && search?.name !== ele?.employeeName) {
                    return null;
                  }
                  return (
                    <Grid item key={"accordian" + index} xs={12}>
                      <AccordianCards
                        item={ele}
                        index={index}
                        setCardData={setCardData}
                        setOpen={(data) => {
                          setUpdateFlag({ ...updateflat, salar: true });
                          setOpen(data);
                        }}
                        setComponentOpen={(data) => {
                          setComponentData(ele["componentDetails"]);
                          setOpenComponentModal(data);
                        }}
                        setComponentData={(data) => {
                          setComponentData(data);
                        }}
                        cardType={value}
                        cardKet={cardKet}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <UpdateComponentModal
          open={openComponentModal}
          setOpen={setOpenComponentModal}
          title={
            value == "SalaryComponents"
              ? "Update Salary Component"
              : value == "incentive"
                ? "Update Salary Incentive"
                : value == "Deductions"
                  ? "Update Deductions"
                  : value == "otherAllowence"
                    ? "Update Other Allowance"
                    : ""
          }
          fields={componentFields[value]}
          cardData={cardData}
          setCardData={setCardData}
          onSubmit={(componentData) => {
            let dataTemp = { ...cardData };
            dataTemp["empId"] = parseInt(dataTemp?.empId);
            // Find and update the specific component in the componentDetails array
            dataTemp.componentDetails = dataTemp.componentDetails.map(
              (component) => {
                if (component.id === componentData.id) {
                  return { ...component, ...componentData };
                }
                return component;
              },
            );

            if (value === "SalaryComponents") {
              dataTemp.componentDetails.forEach((component) => {
                component.percentage = parseFloat(component.percentage);
                component.amount = parseFloat(component.amount);
              });
              updateSalaryComponent(dataTemp, (res) => {
                console.log("resresres ", res);
                if (res.data?.data?.success) {
                  getDataFn();
                  Swal.fire({
                    text: "Updated Successfully",
                    icon: "success",
                    ...swalAlertPopProps,
                  });
                } else {
                  Swal.fire({
                    title: res?.data?.message,
                    icon: "error",
                    ...swalAlertPopProps,
                  });
                }
              });
            } else if (value === "incentive") {
              dataTemp["employeeId"] = dataTemp?.empId;
              dataTemp.componentDetails.forEach((component) => {
                component.percentage = parseFloat(component.percentage ?? 0);
                component.amount = parseFloat(component.amount ?? 0);
                component.minimumValue = parseFloat(
                  component.minimumValue ?? 0,
                );
                component.maximumValue = parseFloat(
                  component.maximumValue ?? 0,
                );
              });
              updateSalaryIncentive(dataTemp, (res) => {
                console.log("resresres ", res);
                if (res.data?.succeeded) {
                  getDataFn();
                  Swal.fire({
                    text: "Updated Successfully",
                    icon: "success",
                    ...swalAlertPopProps,
                  });
                } else {
                  Swal.fire({
                    title: res?.data?.message,
                    icon: "error",
                    ...swalAlertPopProps,
                  });
                }
              });
            } else if (value === "Deductions") {
              dataTemp["employeeId"] = dataTemp?.empId;
              dataTemp.componentDetails.forEach((component) => {
                component.percentage = parseFloat(component.percentage ?? 0);
                component.amount = parseFloat(component.amount ?? 0);
              });
              updateSalaryDeduction(dataTemp, (res) => {
                console.log("resresres ", res);
                if (res.data?.succeeded) {
                  getDataFn();
                  Swal.fire({
                    text: "Updated Successfully",
                    icon: "success",
                    ...swalAlertPopProps,
                  });
                } else {
                  Swal.fire({
                    title: res?.data?.message,
                    icon: "error",
                    ...swalAlertPopProps,
                  });
                }
              });
            } else if (value === "otherAllowence") {
              dataTemp["employeeId"] = dataTemp?.empId;
              dataTemp.componentDetails.forEach((component) => {
                component.percentage = parseFloat(component.percentage ?? 0);
                component.amount = parseFloat(component.amount ?? 0);
              });
              updateAllowance(dataTemp, (res) => {
                console.log("resresres ", res);
                if (res.data?.succeeded) {
                  getDataFn();
                  Swal.fire({
                    text: "Updated Successfully",
                    icon: "success",
                    ...swalAlertPopProps,
                  });
                } else {
                  Swal.fire({
                    title: res?.data?.message,
                    icon: "error",
                    ...swalAlertPopProps,
                  });
                }
              });
            }
          }}
          initialData={componentData}
        />
      </Box>
    </>
  );
};

export default PaymentStruct;
